var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    fill: "#3bb75e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.006315,26.9686872 C100.006315,28.5816922 99.3611131,30.1946973 98.1997494,31.356061 L42.7123746,86.8434358 C41.5510109,88.0047995 39.9380058,88.6500015 38.3250008,88.6500015 C36.7119957,88.6500015 35.0989906,88.0047995 33.9376269,86.8434358 L1.80656569,54.7123746 C0.645202033,53.5510109 0,51.9380058 0,50.3250008 C0,48.7119957 0.645202033,47.0989906 1.80656569,45.9376269 L10.5813133,37.1628793 C11.742677,36.0015156 13.3556821,35.3563136 14.9686872,35.3563136 C16.5816922,35.3563136 18.1946973,36.0015156 19.356061,37.1628793 L38.3250008,56.1963393 L80.6502541,13.8065657 C81.8116178,12.645202 83.4246229,12 85.037628,12 C86.650633,12 88.2636381,12.645202 89.4250018,13.8065657 L98.1997494,22.5813133 C99.3611131,23.742677 100.006315,25.3556821 100.006315,26.9686872 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2aacf77356982e4059adfebf82689fff.svg";
export { ForwardRef as ReactComponent };